import { BaseEntity } from 'src/app/core/domain/base.entity';
import { ObjetoDespesaContaCorrente } from './objeto-despesa-conta-corrente';

export class ObjetoDespesa extends BaseEntity {
  descricao: string;
  ativo: boolean;
  dataCadastro: string;
  listaObjetoDespesaContaCorrente: ObjetoDespesaContaCorrente[];
}
